import { definePreset } from '@primeuix/themes'
import Aura from '@primeuix/themes/aura'

const preset = definePreset(Aura, {
    semantic: {
        formField: {
            paddingX: '2.4rem',
            paddingY: '1.5rem',
            borderRadius: '8px',
            borderWidth: '1px',
        },

        colorScheme: {
            light: {
                formField: {
                    color: 'var(--color-secondary)',
                    background: 'var(--color-neutral-300)',
                    borderColor: 'var(--color-neutral-600)',
                    hoverBorderColor: 'var(--color-neutral-800)',
                    focusBorderColor: 'var(--color-neutral-800)',
                },

                toast: {
                    error: {
                        background: 'var(--color-danger)',
                    },
                },
            },
            dark: {
                formField: {
                    color: 'var(--color-secondary)',
                    background: 'var(--color-neutral-300)',
                    borderColor: 'var(--color-neutral-600)',
                    hoverBorderColor: 'var(--color-neutral-800)',
                    focusBorderColor: 'var(--color-neutral-800)',
                },

                toast: {
                    error: {
                        background: 'var(--color-danger)',
                    },
                },
            },
        },
    },

    components: {
        button: {
            paddingX: '20px',
            paddingY: '8px',
            primary: {
                background: 'var(--color-secondary)',
            },
        },

        datatable: {
            colorScheme: {
                light: {
                    borderColor: 'var(--color-neutral-600)',
                    headerBackground: 'transparent',
                    headerCellBackground: 'var(--color-neutral-500)',
                    headerCellSelectedBackground: 'var(--color-neutral-500)',
                    headerCellSelectedColor: 'var(--color-secondary)',
                    headerCellColor: 'var(--color-secondary)',
                    rowBackground: 'transparent',
                    rowColor: 'var(--color-secondary)',
                    rowStripedBackground: 'var(--color-neutral-300)',
                    paginatorBottomBorderWidth: '0px',
                },
                dark: {
                    borderColor: 'var(--color-neutral-600)',
                    headerBackground: 'transparent',
                    headerCellBackground: 'var(--color-neutral-500)',
                    headerCellSelectedBackground: 'var(--color-neutral-500)',
                    headerCellSelectedColor: 'var(--color-secondary)',
                    headerCellColor: 'var(--color-secondary)',
                    rowBackground: 'transparent',
                    rowColor: 'var(--color-secondary)',
                    rowStripedBackground: 'var(--color-neutral-300)',
                    paginatorBottomBorderWidth: '0px',
                },
            },
        },

        paginator: {
            colorScheme: {
                light: {
                    background: 'transparent',
                    color: 'var(--color-secondary)',
                    hoverBackground: 'transparent',
                    hoverColor: 'var(--color-secondary)',
                    navButtonSelectedBackground: 'var(--color-secondary-800)',
                    navButtonHoverBackground: 'var(--color-secondary-600)',
                },
                dark: {
                    background: 'transparent',
                    color: 'var(--color-secondary)',
                    hoverBackground: 'transparent',
                    hoverColor: 'var(--color-secondary)',
                    navButtonSelectedBackground: 'var(--color-secondary-800)',
                    navButtonHoverBackground: 'var(--color-secondary-600)',
                },
            },
        },

        toast: {
            colorScheme: {
                light: {
                    error: {
                        background: 'var(--color-red-100)',
                        color: 'var(--color-error)',
                    },

                    warning: {
                        background: 'var(--color-yellow-200)',
                        color: 'var(--color-yellow-700)',
                    },

                    info: {
                        background: 'var(--color-blue-200)',
                        color: 'var(--color-link)',
                    },

                    success: {
                        background: 'var(--color-primary-200)',
                        color: 'var(--color-primary-700)',
                    },
                },
                dark: {
                    error: {
                        background: 'var(--color-red-100)',
                        color: 'var(--color-error)',
                    },

                    warning: {
                        background: 'var(--color-yellow-200)',
                        color: 'var(--color-yellow-700)',
                    },

                    info: {
                        background: 'var(--color-blue-200)',
                        color: 'var(--color-link)',
                    },

                    success: {
                        background: 'var(--color-primary-200)',
                        color: 'var(--color-primary-700)',
                    },
                },
            },
        },

        menubar: {
            colorScheme: {
                light: {
                    background: 'transparent',
                    borderColor: 'transparent',
                },
                dark: {
                    background: 'transparent',
                    borderColor: 'transparent',
                },
            },

            item: {
                padding: '0.8rem 2rem',

                light: {
                    color: 'var(--color-secondary-600)',
                    focusColor: 'var(--color-secondary-900)',
                    activeColor: 'var(--color-secondary-900)',
                    background: 'transparent',
                    focusBackground: 'transparent',
                    activeBackground: 'transparent',
                },
                dark: {
                    color: 'var(--color-secondary-600)',
                    focusColor: 'var(--color-secondary-900)',
                    activeColor: 'var(--color-secondary-900)',
                    background: 'transparent',
                    focusBackground: 'transparent',
                    activeBackground: 'transparent',
                },
            },

            submenu: {
                colorScheme: {
                    light: {
                        background: 'var(--color-primary-600)',
                        borderColor: 'transparent',
                    },
                    dark: {
                        background: 'var(--color-primary-600)',
                        borderColor: 'transparent',
                    },
                },
            },
        },

        skeleton: {
            colorScheme: {
                light: {
                    background: 'var(--color-neutral)',
                },
                dark: {
                    background: 'var(--color-neutral)',
                },
            },
        },

        accordion: {
            panelBorderWidth: '0px',
            // panelBorderWidth: '1px',
            // panelBorderColor: 'var(--color-neutral-500)',
            header: {
                firstBorderWidth: '1px',
                padding: '0.6rem 1.2rem',
                colorScheme: {
                    light: {
                        borderColor: 'var(--color-neutral-500)',
                        color: 'var(--color-secondary-900)',
                        activeColor: 'var(--color-secondary-900)',
                        hoverColor: 'var(--color-secondary-900)',

                        iconColor: 'var(--color-secondary-900)',

                        background: 'transparent',
                        activeBackground: 'transparent',
                        hoverBackground: 'transparent',
                        activeHoverBackground: 'transparent',
                    },
                    dark: {
                        borderColor: 'var(--color-neutral-500)',
                        color: 'var(--color-secondary-900)',
                        activeColor: 'var(--color-secondary-900)',
                        hoverColor: 'var(--color-secondary-900)',
                        iconColor: 'var(--color-secondary-900)',

                        background: 'transparent',
                        activeBackground: 'transparent',
                        hoverBackground: 'transparent',
                        activeHoverBackground: 'transparent',
                    },
                },
            },

            content: {
                borderWidth: '1px',
                padding: '1.2rem 1.2rem 0.8rem 1.2rem',
                colorScheme: {
                    light: {
                        borderColor: 'var(--color-neutral-500)',
                        color: 'var(--color-secondary-900)',
                        background: 'transparent',
                    },
                    dark: {
                        borderColor: 'var(--color-neutral-500)',
                        color: 'var(--color-secondary-900)',
                        background: 'transparent',
                    },
                },
            },
        },

        dialog: {
            title: {
                fontSize: '1.6rem',
            },

            header: {
                gap: '2rem',
            },

            colorScheme: {
                light: {
                    background: 'var(--color-neutral-100)',
                    color: 'var(--color-secondary-900)',
                },
                dark: {
                    background: 'var(--color-neutral-100)',
                    color: 'var(--color-secondary-900)',
                },
            },
        },

        select: {
            colorScheme: {
                light: {
                    overlayBackground: 'var(--color-neutral-100)',
                    optionColor: 'var(--color-secondary-900)',
                    optionFocusBackground: 'var(--color-primary-400)',
                    optionFocusColor: 'var(--color-secondary-900)',

                    optionSelectedBackground: 'var(--color-primary-700)',
                    optionSelectedFocusBackground: 'var(--color-primary-700)',
                },
                dark: {
                    overlayBackground: 'var(--color-neutral-100)',
                    optionColor: 'var(--color-secondary-900)',
                    optionFocusBackground: 'var(--color-primary-400)',
                    optionFocusColor: 'var(--color-secondary-900)',

                    optionSelectedBackground: 'var(--color-primary-700)',
                    optionSelectedFocusBackground: 'var(--color-primary-700)',
                },
            },
        },

        multiselect: {
            colorScheme: {
                light: {
                    overlayBackground: 'var(--color-neutral-100)',
                    optionColor: 'var(--color-secondary-900)',
                    optionFocusBackground: 'var(--color-primary-400)',
                    optionFocusColor: 'var(--color-secondary-900)',

                    optionSelectedBackground: 'var(--color-primary-700)',
                    optionSelectedFocusBackground: 'var(--color-primary-700)',
                },
                dark: {
                    overlayBackground: 'var(--color-neutral-100)',
                    optionColor: 'var(--color-secondary-900)',
                    optionFocusBackground: 'var(--color-primary-400)',
                    optionFocusColor: 'var(--color-secondary-900)',

                    optionSelectedBackground: 'var(--color-primary-700)',
                    optionSelectedFocusBackground: 'var(--color-primary-700)',
                },
            },
        },
    },
})

export default {
    theme: {
        preset,
        darkModeSelector: false,
        cssLayer: false,
    },
}
